var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Login',{attrs:{"msg":"Bienvenido al Sistema de Tareas"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }